import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { Sermon } from '../types';

export function useSermon(devotionId: number) {
  const [sermon, setSermon] = useState<Sermon | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Reset state when devotionId changes
    setSermon(null);
    setError(null);
    
    async function fetchSermon() {
      try {
        setIsLoading(true);

        const { data, error: fetchError } = await supabase
          .from('sermons')
          .select('*')
          .eq('devotion_id', devotionId)
          .maybeSingle();

        if (fetchError) {
          throw fetchError;
        }

        console.log('Sermon data loaded:', {
          devotionId,
          title: data?.title,
          songUrl: data?.song_url
        });

        setSermon(data);
      } catch (error: any) {
        console.error('Error fetching sermon:', error);
        setError(error.message || 'Failed to load sermon');
      } finally {
        setIsLoading(false);
      }
    }

    if (devotionId) {
      fetchSermon();
    }
  }, [devotionId]);

  return { sermon, isLoading, error };
}